import React from "react";
import { Button, Menu, Layout, Typography, Card, Row, Col, Space } from "antd";
import {
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  QrcodeOutlined,
  DownOutlined,
} from "@ant-design/icons";
import "./HomePage.css";
import Header from "../../components/Header";
import FooterLayout from "../../components/Footer";
import { Link, useNavigate } from "react-router-dom";

const { Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const HomePage = () => {
  const navigate = useNavigate();
  return (
    <Layout style={{ backgroundColor: "#fff" }}>
      <Header />
      <Content className="main-content">
        <section className="section hero">
          <div className="hero-text">
            <Title level={2}>
              <span className="highlight">Simplify Your</span>
              <br /> PDF Tasks Effortlessly
            </Title>
            <p>
              Access all the essential PDF tools you need in one convenient
              place. Edit, merge, split, compress, convert, and protect your
              PDFs quickly and easily—completely free! Enhance your productivity
              with our user-friendly solutions.
            </p>
            <br />
            <Button
              type="primary"
              size="large"
              shape="round"
              style={{ marginBottom: 40 }}
              onClick={() => {
                navigate("/register");
              }}
            >
              Try for Free
            </Button>
          </div>
          <div className="hero-image">
            <img
              src={require("../../assets/home/hero-graphic.png")}
              alt="PDF Tools"
            />
          </div>
        </section>

        <section className="section tools">
          <Title level={3} className="section-title">
            Most Popular PDF Tools
          </Title>
          <Row gutter={[16, 16]} justify="center">
            <Col xs={24} sm={24} md={12} lg={8}>
              <Link to="/word2pdf">
                <Card className="tool-card" hoverable>
                  <Row wrap={false} gutter={12}>
                    <Col>
                      <img
                        src={
                          require("../../assets/icons/convert_word.svg").default
                        }
                        alt="Word to PDF"
                        style={{ height: 44 }}
                      />
                    </Col>
                    <Col>
                      <h3>Word to PDF</h3>
                      <Paragraph>
                        Make DOC and DOCX files easier to view and share by
                        converting them to PDF in moments.
                      </Paragraph>
                    </Col>
                  </Row>
                </Card>
              </Link>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8}>
              <Link to="/excel2pdf">
                <Card className="tool-card" hoverable>
                  <Row wrap={false} gutter={12}>
                    <Col>
                      <img
                        src={
                          require("../../assets/icons/convert_excel.svg")
                            .default
                        }
                        alt="Excel to PDF"
                        style={{ height: 44 }}
                      />
                    </Col>
                    <Col>
                      <h3>Excel to PDF</h3>
                      <Paragraph>
                        Make XLS and XLSX files easier to view and share by
                        converting them to PDF in moments.
                      </Paragraph>
                    </Col>
                  </Row>
                </Card>
              </Link>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8}>
              <Link to="/ppt2pdf">
                <Card className="tool-card" hoverable>
                  <Row wrap={false} gutter={12}>
                    <Col>
                      <img
                        src={
                          require("../../assets/icons/convert_powerpoint.svg")
                            .default
                        }
                        alt="PowerPoint to PDF"
                        style={{ height: 44 }}
                      />
                    </Col>
                    <Col>
                      <h3>PowerPoint to PDF</h3>
                      <Paragraph>
                        Preserve your slides and make presentations easy to
                        share by converting them to PDF in moments.
                      </Paragraph>
                    </Col>
                  </Row>
                </Card>
              </Link>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8}>
              <Link to="/image2pdf">
                <Card className="tool-card" hoverable>
                  <Row wrap={false} gutter={12}>
                    <Col>
                      <img
                        src={
                          require("../../assets/icons/convert_image.svg")
                            .default
                        }
                        alt="Image to PDF"
                        style={{ height: 44 }}
                      />
                    </Col>
                    <Col>
                      <h3>Image to PDF</h3>
                      <Paragraph>
                        Make JPG and PNG files easier to view and share by
                        converting them to PDF in moments.
                      </Paragraph>
                    </Col>
                  </Row>
                </Card>
              </Link>
            </Col>
          </Row>
        </section>

        {/* <section className="section convert-now">
          <Button type="default" size="large">
            Convert Now
          </Button>
        </section> */}

        <section className="section qr-section">
          <div className="qr-text">
            <Title level={2}>
              Create & Personalize Your Dynamic QR Code for FREE
            </Title>
            <p>
              Generate, manage, and track your QR codes with ease, all in one
              place
            </p>
            <br />
            <Button
              type="primary"
              size="large"
              shape="round"
              onClick={() => {
                navigate("/qr-text");
              }}
            >
              Generate QR Code
            </Button>
          </div>
          <div className="qr-image">
            <img
              src={require("../../assets/home/qr-graphic.png")}
              alt="QR Code Scan"
            />
          </div>
        </section>

        <section className="section mobile-app">
          <div className="app-image">
            <img
              src={require("../../assets/home/app-graphic.png")}
              alt="Mobile App"
            />
          </div>
          <div className="app-text">
            <Title level={2}>Get It on Mobile</Title>
            <p>
              Effortlessly convert Word, Excel, and PowerPoint files to
              high-quality PDFs and create personalized QR codes for easy
              sharing—all from our mobile app. Download now to simplify your
              tasks on the go.
            </p>
            <div className="app-buttons">
              <img
                src={require("../../assets/home/google-play.png")}
                alt="Google Play"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.appsinfinito.love2pdf",
                    "_blank"
                  );
                }}
              />
              <img
                src={require("../../assets/home/app-store.png")}
                alt="App Store"
              />
            </div>
          </div>
        </section>
      </Content>

      <FooterLayout />
    </Layout>
  );
};

export default HomePage;
